import React from 'react';
import { c as classnames } from './index-2586sEvh.js';
import { formatPrice } from './utils/price.js';

/* eslint-disable react/no-array-index-key */
const BedShippingChart = ({ currency, locale, noZeroAfterDecimal, bedShippingCountries, bedShippingValues, country, fees, }) => {
    const bedShippingData = bedShippingCountries.map((element, index) => [
        element,
        bedShippingValues[index],
    ]);
    return (React.createElement("table", { id: "bed-shipping-table", className: "table bed-shipping", cellPadding: "0" },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("th", null, country),
                React.createElement("th", null, fees)),
            bedShippingData.map((currentRow, rowIndex) => (React.createElement("tr", { key: rowIndex * 2 }, currentRow.map((element, elementIndex) => (React.createElement("td", { key: elementIndex, className: classnames({
                    odd: rowIndex % 2 && elementIndex > 1,
                }) }, parseFloat(element)
                ? formatPrice(parseFloat(element), currency, locale, noZeroAfterDecimal)
                : element)))))))));
};

export { BedShippingChart as B };
//# sourceMappingURL=BedShippingChart-5Mamjyyj.js.map
